import {createRouter, createWebHashHistory} from "vue-router";

import Start from "@/views/Start.vue";
import Login from "@/views/Login.vue";
import CompanyOrders from "@/views/CompanyOrders.vue";
import CompanyOrder from "@/views/CompanyOrder.vue";
import DaycareOrders from "@/views/DaycareOrders.vue";
import DaycareOrder from "@/views/DaycareOrder.vue";
import CrateLabel from "@/views/CrateLabel.vue";
import NotFound from "@/views/NotFound.vue";
import PrintRoute from "@/views/PrintRoute.vue";

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      requiresNoAuthentication: true,
    }
  },
  {
    path: '/start',
    name: 'Start',
    component: Start,
  },
  {
    path: '/bedrijven-bestellingen',
    name: 'CompanyOrders',
    component: CompanyOrders,
  },
  {
    path: '/bedrijven-bestelling/:orderid',
    name: 'CompanyOrder',
    component: CompanyOrder,
    props: true
  },
  {
    path: '/kinderdagverblijf-bestellingen',
    name: 'DaycareOrders',
    component: DaycareOrders,
  },
  {
    path: '/kinderdagverblijf-bestelling/:orderid',
    name: 'DaycareOrder',
    component: DaycareOrder,
    props: true
  },
  {
    path: '/kratlabel/:customername/:date/:city',
    name: 'CrateLabel',
    component: CrateLabel,
    props: true
  },
  {
    path: '/PrintRoute/:routeName/:weekFilter',
    name: 'PrintRoute',
    component: PrintRoute,
    props: true
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  }
]


const router = createRouter({
  history: createWebHashHistory(),
  routes, // short for `routes: routes`
  linkActiveClass: "activeNav"
})

// check if loggedin
router.beforeEach((to) => {
  if (!to.meta.requiresNoAuthentication && !window.localStorage.getItem("loggedin")) {
    return { name: 'Login', query: {redirect: to.fullPath}}
  }
})

export default router;